import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import PropTypes from 'prop-types';

import Portlet from '../layout/Portlet';
import { formatCurrencyRounded, isNil } from 'vdlib';

import LookupsHelper from 'lib/LookupsHelper';

import { Card, Descriptions } from 'antd';
import { ShopOutlined } from '@ant-design/icons';

const descriptionDetailsStyle = {
  fontSize: 16,
  fontWeight: 600,
};

class AuctionMerchantData extends React.Component {
  render() {
    if (isNil(this.props.data)) return false;

    return (
      <Card
        headStyle={{ background: '#f7ebbb' }}
        title={
          <div>
            <span>
              <ShopOutlined
                style={{
                  fontSize: 22,
                  color: '#6d6d6d',
                  verticalAlign: '0em',
                  marginRight: 5,
                }}
              />
            </span>
            <span style={{ fontSize: 18, fontWeight: 600, color: '#6d6d6d' }}>
              {`${I.t('AGENT_C')}:  ${this.props.data.DistinctiveTitle}`}
            </span>
          </div>
        }
      >
        <Descriptions className="profile" colon={false} size="small" bordered>
          <Descriptions.Item label={I.t('NAME_SURNAME')} span={3}>
            <span style={descriptionDetailsStyle}>
              {`${this.props.data.FirstName || '-'} ${
                this.props.data.SurName || ''
              }`}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('OFFER')}>
            <span style={descriptionDetailsStyle}>
              {`${formatCurrencyRounded(this.props.bidAmount)}`}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('INITIAL_PRICE_SHORT')} span={2}>
            <span style={descriptionDetailsStyle}>
              {`${
                this.props.initialAmount
                  ? formatCurrencyRounded(this.props.initialAmount)
                  : null
              }`}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('TAXNUMBER')}>
            <span style={descriptionDetailsStyle}>
              {this.props.data.AFM || '-'}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('TAXOFFICE')} span={2}>
            <span style={descriptionDetailsStyle}>
              {' '}
              {LookupsHelper.getDescription(
                this.props.taxOffices,
                this.props.data.TaxOfficeID
              )}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('ADDRESS')} span={3}>
            <span style={descriptionDetailsStyle}>
              {`${this.props.data.Address || '-'} `}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('PHONE_SHORT')}>
            <span style={descriptionDetailsStyle}>{`${
              this.props.data.Phone || '-'
            } `}</span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('FAX')}>
            <span style={descriptionDetailsStyle}>{`${
              this.props.data.Fax || '-'
            } `}</span>
          </Descriptions.Item>
          <Descriptions.Item label={I.t('MOBILE')}>
            <span style={descriptionDetailsStyle}>{`${
              this.props.data.Mobile || '-'
            } `}</span>
          </Descriptions.Item>
        </Descriptions>
      </Card>
    );
  }
}

AuctionMerchantData.propTypes = {
  data: PropTypes.object,
  taxOffices: PropTypes.array,
  bidAmount: PropTypes.number,
  initialAmount: PropTypes.number,
};

export default AuctionMerchantData;
